import * as React from "react";
import "./EqSchoolActivityBoard.scss";
import { Tabs, Skeleton } from "antd";
import { ApiEndpoints } from "../../shared/Common";
import Api from "../../shared/Api";
import { useTranslation } from "react-i18next";
import TabPane from "antd/lib/tabs/TabPane";
import EqSchoolTrainings from "../schoolTrainings/EqSchoolTrainings";
import { Badge } from "antd-v5";
import AnimationDiv from "../../custom/animationDiv/AnimationDiv";
import RevealList from "../../custom/RevealList/RevealList";
import EqSchoolTrainingsPrevious from "../schoolTrainingsPrevious/EqSchoolTrainingsPrevious";
import EqPublicEventBoard from "../../../eqComponents/publicEvents/eqPublicEventBoard/EqPublicEventBoard";
import EqPublicEventPreviousBoard from "../../eqTrainer/eqPublicEventPreviousBoard/EqPublicEventPreviousBoard";

const EqSchoolActivityBoard = () => {
    const { t, i18n } = useTranslation();
    const [isError, setIsError] = React.useState(false);

    const [trainingsCount, setTrainingsCount] = React.useState(0);
    const [productCount, setProductCount] = React.useState(0);
    const [eventsCount, setEventsCount] = React.useState(0);

    const [isLoading, setIsLoading] = React.useState(false);

    const fetchCounts = () => {
        Api.get(ApiEndpoints.GetSchoolTrainingEventCount)
            .then((response) => {
                if (response && response.status === 200) {
                    // Assuming the response data is an object with keys for counts
                    const { trainingCount, schoolProductCount, eventsCount } = response.data;

                    setTrainingsCount(trainingCount);
                    setProductCount(schoolProductCount);
                    setEventsCount(eventsCount);

                    console.log(response.data);
                } else {
                    setIsError(true);
                }
            })
            .catch((error) => {
                setIsError(true);
            });
    };

    const updateTrainingCount = (count: number) => {
        fetchCounts();
        setActiveTab("1");
        setTrainingsCount(count);
    };

    const updateEventsCount = (count: number) => {
        fetchCounts();
        setActiveTab("2");
        setEventsCount(count);
    };

    // const [activeTab, setActiveTab] = React.useState(defaultActiveTab());
    const [activeTab, setActiveTab] = React.useState("2");

    const [activeEvent, setActiveEvent] = React.useState(null);

    React.useEffect(() => {
        fetchCounts();
        // setActiveTab(defaultActiveTab)
        const params = new URLSearchParams(window.location.search);
        var tabKey = params.get("tab");
        if (tabKey !== null) {
            setActiveTab(tabKey);
        }
        window.scrollTo(0, 0);

        if (trainingsCount >= 0 && productCount >= 0 && eventsCount >= 0) {
            setIsLoading(false);
        }
    }, [trainingsCount, productCount, eventsCount]);

    return (
        <AnimationDiv>
            <div className={`eq-school-activity-board`}>
                <div className="eq-container-fluid">
                    {/* <Row className="eq-tp-heading-row" align="middle" justify="start">
          <Col className="eq-tp-heading-col" flex="auto">
            <h2 className="eq-tp-heading">{t("All Activities")}</h2>
          </Col>
        </Row> */}
                    {isLoading ? (
                        <div>
                            <Skeleton active />
                        </div>
                    ) : (
                        <Tabs
                            className="ab-tabs"
                            // onChange={onChange}
                            type="card"
                            activeKey={activeTab}
                            onChange={(key) => {
                                setActiveTab(key);
                            }}
                        >
                            <TabPane
                                tab={
                                    <span>
                                        {t("trainings")}{" "}
                                        <Badge
                                            count={trainingsCount}
                                            offset={[0, -15]}
                                            className="tab-badge"
                                            size="default"
                                        ></Badge>
                                    </span>
                                }
                                key="1"
                            >
                                <RevealList>
                                    <EqSchoolTrainings updateCount={updateTrainingCount} />
                                </RevealList>
                            </TabPane>

                            {/* <TabPane
                tab={
                  <span>
                    {t("ridingCourses")}{" "}
                    <Badge
                      count={productCount}
                      offset={[0, -15]}
                      className="tab-badge"
                      size="default"
                    >
                    </Badge>
                  </span>}
                key="2">
                <RevealList>
                  <EqSchoolProductTrainings
                    updateCount={updateProductCount} />
                </RevealList>
              </TabPane> */}

                            <TabPane
                                tab={
                                    <span>
                                        {t("events")}{" "}
                                        <Badge
                                            count={eventsCount}
                                            offset={[0, -15]}
                                            className="tab-badge"
                                            size="default"
                                        ></Badge>
                                    </span>
                                }
                                key="2"
                            >
                                <RevealList>
                                    <EqPublicEventBoard
                                        updateCount={updateEventsCount}
                                        
                                    />
                                </RevealList>
                            </TabPane>

                            <TabPane tab={<span>{t("previousEvents")} </span>} key="4">
                                <RevealList>
                                    <EqPublicEventPreviousBoard
                                        updateCount={updateEventsCount}
                                        
                                    />
                                </RevealList>
                            </TabPane>

                            <TabPane tab={<span>{t("previousTrainings")} </span>} key="5">
                                <RevealList>
                                    <EqSchoolTrainingsPrevious />
                                </RevealList>
                            </TabPane>
                        </Tabs>
                    )}
                </div>
            </div>
        </AnimationDiv>
    );
};
export default EqSchoolActivityBoard;
